<template>
  <div :class="['row', 'obsform__multichoice', {'row--primary': primary}]">
    <div v-if="label" class="col-12">
      <h2>{{ label }}</h2>
    </div>
    <div class="col-12">
      <div v-for="(option, index) in options" :class="['obsform__multichoice__option', 'custom-control', 'custom-radio', { disabled: option.disabled }]">
        <input type="radio"
               class="custom-control-input"
               :id="`multichoice-${uid}-${index}`"
               :value="option.value"
               :checked="value === option.value"
               :disabled="option.disabled"
               @change="updateValue($event.target.value)">
        <label :for="`multichoice-${uid}-${index}`" class="custom-control-label">{{ option.label }}</label>
      </div>
      <div v-if="other" class="obsform__multichoice__option obsform__multichoice__option--other custom-control custom-radio">
        <input type="radio"
               class="custom-control-input"
               :id="`multichoice-${uid}-other`"
               value="other"
               :checked="showOther"
               @change="updateValue($event.target.value)">
        <label :for="`multichoice-${uid}-other`" class="custom-control-label">Other (please specify)</label>
      </div>
      <div v-if="showOther" class="obsform__multichoice__other">
        <input type="text"
               :id="`multichoice-${uid}-otherValue`"
               v-model="otherValue"
               @input="updateOtherValue($event.target.value)"
               maxlength="100">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        showOther: false,
        otherValue: '',
        uid: null,
      }
    },
    props: {
      label: String,
      options: Array,
      value: [String, Number, Boolean],
      type: String,
      primary: Boolean,
      other: Boolean,
    },
    methods: {
      updateValue: function(value) {
        if (this.type === 'boolean') {
          value = (value === 'true');
        } else if (this.type === 'number') {
          value = Number(value);
        }
        if (this.other && value === 'other') {
          this.showOther = true;
          this.$emit('input', this.otherValue);
        } else {
          this.showOther = false;
          this.$emit('input', value);
        }
      },
      updateOtherValue: function(value) {
        this.$emit('input', value);
      },
    },
    mounted() {
      this.uid = this.$vnode.key;

      if (typeof(this.value) !== 'undefined' && this.value !== null && this.value.length > 0) {
        let found = this.options.find((option) => {
          return this.value === option.value;
        });

        if (!found) {
          this.showOther = true;
          this.otherValue = this.value;
        }
      }
    }
  }
</script>
